export default __webpack_public_path__ + "static/media/fridge2-beforeA-2048w.f605927e.avif";